import { get } from "../api";
import { useQuery } from "@tanstack/react-query";
import { IconCopy } from "@tabler/icons-react";
import useNotification from "../notification/use_notification";
function EmailList() {
  const notify = useNotification();
  const emailList = useQuery({
    queryKey: ["emails"],
    queryFn: () => get("/email"),
  });
  const orderEmails = useQuery({
    queryKey: ["order_emails"],
    queryFn: () => get("/email/orders"),
  });
  const handleCopy = (list) => {
    if (list) {
      navigator.clipboard.writeText(
        emailList.data.map((x) => x.email).join("\n")
      );
    } else {
      navigator.clipboard.writeText(orderEmails.data.join("\n"));
    }
    notify.success("Copied!");
  };
  return (
    <div>
      <div className="w-96 h-100 border rounded-lg shadow-lg p-4">
        <div className="flex items-center justify-between">
          <span className="text-lg font-semibold pe-2">
            Emails for newsletter
          </span>
          <button
            onClick={() => handleCopy(true)}
            className="hover:text-gray-400"
          >
            <IconCopy />
          </button>
        </div>
        {emailList.isSuccess &&
          emailList.data.map((email, idx) => (
            <div key={idx}>{email.email}</div>
          ))}
      </div>

      <div className="w-96 h-100 border rounded-lg shadow-lg p-4">
        <div className="flex items-center justify-between">
          <span className="text-lg font-semibold pe-2">Emails from orders</span>
          <button
            onClick={() => handleCopy(false)}
            className="hover:text-gray-400"
          >
            <IconCopy />
          </button>
        </div>
        {orderEmails.isSuccess &&
          orderEmails.data.map((email, idx) => <div key={idx}>{email}</div>)}
      </div>
    </div>
  );
}
export default EmailList;
